import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ISbRichtext, ISbStoriesParams } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-poster',
  standalone: true,
  imports: [
    RouterModule,
    DynamicModule,
    NgClass,
    NgIf,
    NgFor,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
    StoryblokRichTextDirective,
  ],
  templateUrl: './poster.component.html',
  styleUrl: './poster.component.scss',
})
export class PosterComponent implements OnInit, OnChanges {
  @Input() headline!: string;
  @Input() content!: ISbRichtext;
  @Input() image!: ISbStoriesParams;

  @Input() layout!: string;
  @Input() actions!: any[];
  @Input() accordions!: any[];

  @Input() eyebrow!: string;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;

  @Input() size: string = '739x503';

  @Input() offset_top: number = 0;
  @Input() offset_left: number = 0;
  @Input() offset_right: number = 0;
  @Input() offset_bottom: number = 0;
  @Input() reverse_order: boolean = false;
  @Input() background: string = '';
  @Input() align_y: string = 'align-items-start';
  @Input() content_max_width: number | undefined = undefined;
  components: any;

  width!: string;
  height!: string;
  constructor(private el: ElementRef, private renderer: Renderer2) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnInit(): void {
    const sizes = this.size.split('x');
    this.width = sizes[1];
    this.height = sizes[0];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-color',
      this.background
    );
  }
}
